import { ReactNode } from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Tooltip,
} from '@mui/material'

interface IProps {
  title?: string
  message?: string
  children?: ReactNode
  open: boolean
  onConfirm: any
  setOpen: any
  onCancel?: any
  option1?: string
  option2?: string
  tooltip1?: string
  tooltip2?: string
  closeAfterTransition?: boolean
  disableConfirmButton?: boolean
}

const ConfirmDialog = (props: IProps) => {
  const {
    title = 'Discard changes',
    message = "You have made changes that haven't been saved yet. Are you sure to discard changes?",
    children,
    open,
    setOpen,
    onConfirm,
    onCancel,
    option1 = 'no',
    option2 = 'yes',
    tooltip1,
    tooltip2,
    closeAfterTransition,
    disableConfirmButton = false,
  } = props

  const handleOnClose = () => {
    setOpen(false)

    if (onCancel) {
      onCancel()
    }
  }
  const handleOnConfirm = () => {
    onConfirm()
    handleOnClose()
  }

  return (
    <Dialog
      maxWidth='xs'
      open={open}
      onClose={handleOnClose}
      aria-labelledby='confirm-dialog'
      closeAfterTransition={closeAfterTransition}>
      <DialogTitle id='confirm-dialog'>{title}</DialogTitle>
      <DialogContent>{children || <DialogContentText>{message}</DialogContentText>}</DialogContent>
      <DialogActions>
        <Tooltip title={tooltip1}>
          <Button variant='contained' color='grey' onClick={handleOnClose}>
            {option1}
          </Button>
        </Tooltip>
        <Tooltip title={tooltip2}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOnConfirm}
            disabled={disableConfirmButton}>
            {option2}
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
